<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 订单管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>订单冲账</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.orderNo" placeholder="订单号" class="handle-input mr10" style="width:180px"></el-input>
				<el-input v-model="query.orderCompanyName" placeholder="客户名称" class="handle-input mr10" style="width:180px"></el-input>
				<el-select v-model="query.payConfirmId" placeholder="请选择冲账确认状态或操作人">
						<el-option key="" label="请选择冲账确认状态或操作人" value=""></el-option>
						<el-option key="0" label="待确认" value="0"></el-option>
						<el-option v-for="item in payConfirmUsersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				&nbsp;
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.createTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.createTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
				></el-date-picker>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
				<el-table-column prop="orderCompanyName" label="客户名称"></el-table-column>
				<el-table-column prop="total" label="数量" width="60"></el-table-column>
				<el-table-column prop="amount" label="金额" width="90"><template slot-scope="scope">￥{{scope.row.amount}}</template></el-table-column>
				<el-table-column prop="payType" label="付款方式" :formatter="payTypeFormat" width="100">
					<template slot-scope="scope">
					<el-tag :type= "scope.row.payReceipt?'success':((scope.row.payType===2 && new Date(scope.row.payTime).getTime() < new Date().getTime())?'danger':'warning')" >{{payTypeFormat(null, null, scope.row.payType)}}
					</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="balancePayment" label="余额支付" width="100"></el-table-column>
				<el-table-column prop="payReceipt" label="支付回单" width="100">
					<template slot-scope="scope" v-if="scope.row.payReceipt">
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in scope.row.payReceipt.split(',')">
							<el-image
								class="table-td-thumb"
								:src="imgPrefix+payReceiptItem"
								:preview-src-list="[imgPrefix+payReceiptItem]"
								v-if = "scope.row.payReceipt"
							></el-image>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="payConfirmId" label="冲账确认" width="150">
					<template slot-scope="scope">
						{{scope.row.payConfirmId > 0?"已确认(" + scope.row.payConfirmName + ")":"待确认"}}
					</template>
				</el-table-column>
				<el-table-column prop="payConfirmTime" label="确认时间" width="160"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="handleConfirm(scope.$index, scope.row)"
							v-if = "controll['confirm'] && scope.row.payReceipt && scope.row.payConfirmId === 0"
                        >确认</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		<!-- 编辑确认 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="冲账确认" :visible.sync="paidConfirmVisible" width="40%">
			<el-form ref="paidConfirmForm" :model="paidConfirmForm" label-width="100px">
				<el-form-item label="订单号: " >
					{{paidConfirmForm.orderNo}}
				</el-form-item>
				<el-form-item label="客户名称: " >
					{{paidConfirmForm.orderCompanyName}}
				</el-form-item>
				<el-form-item label="订单金额: " >
					￥{{paidConfirmForm.amount}}
				</el-form-item>
				<el-form-item label="余额支付: " v-if="paidConfirmForm.balancePayment > 0">
					￥{{paidConfirmForm.balancePayment}}
				</el-form-item>
				<el-form-item label="现金支付回单: " v-if = "paidConfirmForm.payReceipt">
					<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in paidConfirmForm.payReceipt.split(',')">
						<div style="float:left">
							<el-image
								class="table-td-thumb"
								:src="imgPrefix+payReceiptItem"
								:preview-src-list="[imgPrefix+payReceiptItem]"
							></el-image>
						</div>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="冲账说明: " prop="payConfirmRemark">
					<el-input type=textarea :rows=3 v-model="paidConfirmForm.payConfirmRemark"> </el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="paidConfirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="payConfirm()" v-prevent-re-click>提交</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="冲账详情" :visible.sync="paidConfirmShowVisible" width="40%">
			<el-form ref="paidConfirmShow" :model="paidConfirmShow" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							订单号
						</template>
						{{paidConfirmShow.orderNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							客户名称
						</template>
						{{paidConfirmShow.orderCompanyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							订单金额
						</template>
						￥{{paidConfirmShow.amount}}
					</el-descriptions-item>
					<el-descriptions-item v-if="paidConfirmShow.balancePayment > 0">
						<template slot="label">
							余额支付
						</template>
						￥{{paidConfirmShow.balancePayment}}
					</el-descriptions-item>
					<el-descriptions-item v-if = "paidConfirmShow.payReceipt">
						<template slot="label">
							现金支付回单
						</template>
						<el-tooltip content="点击图片放大" placement="right" v-for = "payReceiptItem in paidConfirmShow.payReceipt.split(',')">
							<div style="float:left">
								<el-image
									class="table-td-thumb"
									:src="imgPrefix+payReceiptItem"
									:preview-src-list="[imgPrefix+payReceiptItem]"
								></el-image>
							</div>
						</el-tooltip>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							操作人
						</template>
						{{paidConfirmShow.payConfirmName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							冲账时间
						</template>
						{{paidConfirmShow.payConfirmTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							冲账说明
						</template>
						{{paidConfirmShow.payConfirmRemark}}
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPaidData, paidConfirm, getOrder, getFinanceUser } from '../../../api/index';
export default {
    name: 'advantage-total',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			payTypeConfig : {
								"0":"款到发货", 
								"1":"快递代收", 
								"2":"账期付款"
							},
			imgPrefix:"/image",
			paidConfirmVisible:false,
			paidConfirmForm:{},
			paidConfirmShow:false,
			paidConfirmShowVisible:false,
			payConfirmUsersKV:[],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("order-paid-confirm");
		this.payConfirmUsers();
        this.getData();
    },
    methods: {
		//支付方式格式化
		payTypeFormat(row, column, cellValue) {
			return this.payTypeConfig[cellValue];
		},
		// 获取数据
        getData() {
            fetchPaidData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		// 获取
        payConfirmUsers() {
            getFinanceUser(this.query).then(res => { 
				if (res.code == 0 ) {
					this.payConfirmUsersKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		// 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleShow(index, row) {
			this.paidConfirmShowVisible = true;
			this.paidConfirmShow = row;
		},
		handleConfirm(index, row) {
			getOrder(row.id).then(res => {
				if (res.code == 0) {
					this.paidConfirmForm = res.data;
					this.paidConfirmVisible = true;
				} else {
					this.$message.error(`获取订单详情失败！` + res.message);
				}
			})
		},
		payConfirm() {
			this.$confirm('确定订单款项已经到账吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let confirmInfo = {};
					confirmInfo.id = this.paidConfirmForm.id;
					confirmInfo.payConfirmRemark = this.paidConfirmForm.payConfirmRemark;
					paidConfirm(confirmInfo).then(res => {
						if (res.code == 0 ) {
							this.$message.success(`冲账确认成功！`);
							this.paidConfirmVisible = false;
							this.getData();
						} else {
							this.$message.error("冲账确认失败！" + res.message);
						}
					});
                })
                .catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    width: 40px;
    height: 30px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.text {
	font-size: 14px;
}

.item {
	margin-bottom: 18px;
	border-bottom:1px solid #E0E0E0;
}
</style>
